import { render, staticRenderFns } from "./RssFeedManagement.vue?vue&type=template&id=0b38ff18&scoped=true"
import script from "./RssFeedManagement.vue?vue&type=script&lang=js"
export * from "./RssFeedManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b38ff18",
  null
  
)

export default component.exports